import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'
import { ChanneledRequestParams } from 'types'

import { getDepartments } from './requests'

export const useDepartmentsQuery = (params: ChanneledRequestParams) => {
  return useQuery({
    queryKey: [QueryKey.GetDepartments, params],
    queryFn: () => getDepartments(params),
  })
}
